import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className, AwaitModules, Button, openContent } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_NextSteps } from '../../../_shared.js';
import './AdvisorPanel_NextSteps.scss';
import { colors, ICONS } from '@app/styles';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { advisorConfig_EnableKickstart } from '../../../modules/ModuleFE_AdvisorSettings/index.js';
import { Component_MetaPathway } from '../../components/next-steps/metapathway/Component_MetaPathway.js';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import { Dialog_Cockpit, ModulesToAwait_Cockpit } from '../../dialogs/Dialog_Cockpit/Dialog_Cockpit.js';
import { Renderer_EncounterEnd } from './Renderer_EncounterEnd/Renderer_EncounterEnd.js';
import { Component_MetapathwayOrderCart } from '../../components/next-steps/metapathway-order-cart/Component_MetapathwayOrderCart.js';
import { iconTooltipId } from '../../_style/icon-tooltip/index.js';
import { Component_SL_Text } from '@app/styles/skeleton-loaders';
import { dispatch_OnAddProtocol } from '../AdvisorPanel_AddProtocolData/renderers/Renderer_AddProtocol/dispatchers.js';
import { ConsiderationGroupEnum } from '@app/advisor-shared';
export class AdvisorPanel_NextSteps extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_NextSteps,
    };
    __onReadOnlyChanged() {
        // @ts-ignore
        this.state.readonly = ModuleFE_EMInterface.isReadonly();
        this.forceUpdate();
    }
    __onAdvisorSettingsUpdated(key) {
        if (key !== advisorConfig_EnableKickstart)
            return; // ignore if not kickstart related
        // force update in order to show or hide the kickstart button
        this.forceUpdate();
    }
    __onProtocolInteraction = () => {
        ModuleFE_ScrollBar.updateScrollBar(this.scrollRef);
    };
    __onPathwayEndUpdated() {
        this.setState({ postDisposition: ModuleFE_EMInterface.isPostDisposition() });
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.readonly = ModuleFE_EMInterface.isReadonly();
        state.postDisposition = ModuleFE_EMInterface.isPostDisposition();
        return state;
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__next-steps');
    }
    getPanelStyle() {
        if (!ModuleFE_EMInterface.isPostDisposition())
            return super.getPanelStyle();
        //Set the color as primary 2 for now
        return { ...super.getPanelStyle(), '--dp-color': colors.primary['primary-01'] };
    }
    openAddProtocol = (e) => {
        e.stopPropagation();
        if (ModuleFE_EMInterface.isReadonly())
            return;
        dispatch_OnAddProtocol.dispatchUI(ConsiderationGroupEnum.HIGH_CONSIDERATION);
    };
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        if (!ModuleFE_EMInterface.isPostDisposition())
            return 'Key Differentials & Workup';
        return 'Disposition';
    };
    renderHeader_Tail = () => {
        return _jsxs(AwaitModules, { modules: ModulesToAwait_Cockpit, customLoader: _jsx(Component_SL_Text, { width: 100 }), children: [_jsx(Button, { ...openContent.tooltip.bottom(iconTooltipId, 'Overall view of patient data', { offset: 8 }), variant: 'header-button', onClick: () => Dialog_Cockpit.show(), children: "Cockpit" }), !this.state.readonly && _jsx(ICONS.advisor_avn_add.component, { onClick: this.openAddProtocol })] });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    renderContent = () => {
        if (this.state.postDisposition)
            return _jsx(Renderer_EncounterEnd, {});
        return _jsx(Component_MetaPathway, {});
    };
    //######################### Render - Footer #########################
    renderFooter = () => _jsx(Component_MetapathwayOrderCart, {});
}
//# sourceMappingURL=AdvisorPanel_NextSteps.js.map